import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { setCurrentCurrencyCode } from './store/currencies/index.js';
import { selectCurrencyCodes, selectCurrentCurrencyCode } from './storeSelectors/currencies.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import './index-QrdBfapu.js';
import { getCookie, setCookie } from './utils/cookies.js';
import { c as COOKIE_LOCALITY_NAME, b as COOKIE_CURRENCY_NAME, n as COOKIE_CURRENCY_PREF } from './cookies-l-jEMp6P.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-vPolXUOt.js';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-qyZpLI0y.js';
import { C as CurrencyCode } from './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-5CMab_Gs.js';
import 'lodash';
import { getCurrencySign } from './utils/currency.js';
import './utils/price.js';
import 'next/server';
import './index-Oip0gjfj.js';
import './graphqlRequestClient-7kdUKc_c.js';
import { D as Drawer } from './Drawer-J1RjFs7M.js';
import Link from './components/Link/index.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

/* eslint-disable jsx-a11y/anchor-is-valid */
const CurrencyDrawer = ({ isOpen, onClose }) => {
    var _a;
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { useDispatch, useSelector } = useContext(CoreContext);
    const { reload } = useRouter();
    const dispatch = useDispatch();
    const localityCookie = getCookie(COOKIE_LOCALITY_NAME);
    const currencyCodes = useSelector(selectCurrencyCodes);
    const currentCurrencyCodeFromStore = useSelector(selectCurrentCurrencyCode);
    const currentCurrencyCode = (_a = currentCurrencyCodeFromStore !== null && currentCurrencyCodeFromStore !== void 0 ? currentCurrencyCodeFromStore : localityCookie) !== null && _a !== void 0 ? _a : CurrencyCode.EUR;
    const handleChangeCurrency = (item) => {
        const fallbackCurrency = currencyCodes.includes(item) ? item : CurrencyCode.EUR;
        setCookie(COOKIE_CURRENCY_NAME, fallbackCurrency);
        setCookie(COOKIE_CURRENCY_PREF, fallbackCurrency);
        dispatch(setCurrentCurrencyCode(fallbackCurrency));
        reload();
    };
    const ref = useAutoFocus({ tag: 'button' });
    return (React.createElement(Drawer, { open: isOpen, onClose: onClose, name: "currency" },
        React.createElement("h1", { className: "title" }, tLabel('currencySelection')),
        React.createElement("ul", { ref: ref, className: "currency-drawer-list" }, currencyCodes.map((currencyCode, index) => (React.createElement("li", { key: currencyCode, "aria-label": `Item ${index + 1}. ${currencyCode}.` },
            React.createElement(Link, { className: classnames('drawer-option button-reset', {
                    active: currentCurrencyCode === currencyCode,
                }), onClick: () => handleChangeCurrency(currencyCode), noUnderline: true },
                React.createElement("span", { "data-testid": `currency-code-${currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toLowerCase()}`, className: "currency-code" }, currencyCode),
                currencyCode !== CurrencyCode.AED && currencyCode !== CurrencyCode.CHF && (React.createElement("span", null, getCurrencySign(currencyCode))))))))));
};
var CurrencyDrawer$1 = withProviders(CurrencyDrawer, { translation: true });

export { CurrencyDrawer$1 as C };
//# sourceMappingURL=CurrencyDrawer-sJZI_1PD.js.map
